import React, { PropTypes } from 'react';
import { NitroText } from 'nitro-components';
import { media } from 'style-utils';

import styled from 'styled-components';
import SectionHeader from "../layouts/SectionHeader";

const Wrapper = SectionHeader.extend`
  font-size: 12px;
  align-items: center;
  line-height: inherit;

  ${media.mobile`
    flex-direction: column-reverse;
    width: 100%;
    text-align: center;
  `}

  ${media.mobileTablet`
    min-height: 75px;
  `}
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column
`;

const Ancap = styled.div`
  width: 100px;
  height: 45px;
  background-size: 100%;
  background-repeat: no-repeat;
  text-indent: -5000px;

  ${props => props.ancap && `
    background-image: url(${require(`../../assets/images/ancap-${props.ancap}.svg`)});
  `}
`;

const NoAncap = Ancap.extend`
  width: 150px;
  text-indent: 0;
  text-align: right;
`;
// <div className={'ancap ancap-' + Math.ceil(ancapRating)} />
const VehicleStats = ({ co2Emissions, fuelConsumption, ancapRating }) => {
  return (
    <Wrapper size="small" noMarginChildren>
      <InfoWrapper>
        <div>CO2 (g/km): <NitroText variant="secondary">{co2Emissions || 'N/A'}</NitroText></div>
        <div>Fuel (L/100km): <NitroText variant="secondary">{fuelConsumption || 'N/A'}</NitroText></div>
      </InfoWrapper>
      {ancapRating
        ? <Ancap ancap={Math.ceil(ancapRating)} />
        : <NoAncap>Ancap rating: N/A</NoAncap>}
    </Wrapper>
  );
};

VehicleStats.propTypes = {
  ancapRating: PropTypes.number,
  co2Emissions: PropTypes.string,
  fuelConsumption: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default VehicleStats;



// WEBPACK FOOTER //
// ./src/components/vehicle/VehicleStats.js